if (!customElements.get("site-switcher")) {
  class SiteSwitcher extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector(".disclosure__button");
      this.panel = this.querySelector(".disclosure__list");
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.button.addEventListener("click", this.toggle.bind(this));
      this.button.addEventListener("keydown", (event) => {
        if (event.code === "Enter" || event.code === "Space") {
          event.preventDefault();
          this.toggle();
        }
      });
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() !== "ESCAPE") return;
        this.hidePanel();
        this.button.focus();
      });
    }

    handleBodyClick(event) {
      if (!this.contains(event.target)) this.hidePanel();
    }

    toggle() {
      if (this.button.classList.contains("opend")) {
        this.hidePanel();
        return;
      }
      // Close any other open localization dropdowns, same as LocalizationForm
      for (const item of document.querySelectorAll(".button-localization")) {
        item.classList.remove("opend");
      }
      for (const item of document.querySelectorAll(".disclosure__list")) {
        item.classList.add("hidden");
      }
      document.body.addEventListener("click", this.onBodyClick);
      this.button.classList.add("opend");
      this.button.setAttribute("aria-expanded", "true");
      this.panel.classList.remove("hidden");
    }

    hidePanel() {
      document.body.removeEventListener("click", this.onBodyClick);
      this.button.classList.remove("opend");
      this.button.setAttribute("aria-expanded", "false");
      this.panel.classList.add("hidden");
    }
  }
  customElements.define("site-switcher", SiteSwitcher);
}
